import MockTermConstants from '@uw-it-sis/lib-js-common/lib/MockTermConstants';

// We used to export this as both a "named" and "default" export,
// so export both ways just in case.
export { MockTermConstants };
export default MockTermConstants;